/**
 * За сайта / About. The Bulgarian is the authoritative text; the English is a
 * translation of it. Claims carry a `verified:` comment naming the file that
 * makes them true. The "last updated" date is this file's last commit.
 */

import { Link } from 'react-router'

export function AboutBg() {
  return (
    <>
      <p>
        {/* verified: CLAUDE.md (what this is) */}
        „Чети по реда“ отговаря на въпроса, с който започва всеки голям фентъзи свят: от коя книга да започна. За всеки свят има пътища
        — поредици от книги с начало и край, — и до всяка книга пише защо стои точно там.
      </p>
      <p>
        {/* verified: seeds/works.discworld.json (one universe, discworld) */}
        Първият свят е Света на Диска на Тери Пратчет. Сайтът е направен така, че да побере и други.
      </p>
      <h2>Как е направен</h2>
      <p>
        {/* verified: seeds/works.discworld.json (_synopsis_provenance; _verification_status: titles and names checked against the printed Bulgarian editions) */}
        Резюметата и бележките са написани на ръка, за този сайт. Българските заглавия и имената в текстовете са проверени срещу
        отпечатаните български издания.
      </p>
      <p>
        {/* verified: CLAUDE.md (personal project, free, no advertising) */}
        Сайтът е личен проект. Безплатен е, без реклами, и не е свързан с авторите, наследниците им или издателите.
      </p>
      <p>
        {/* verified: chetiporeda-web (the site at about.chetiporeda.com, issue web#1) */}
        Повече за това какво е проектът и как работи: <a href="https://about.chetiporeda.com">about.chetiporeda.com</a>.
      </p>
      <p>
        Грешка в реда, свят, който да добавим, или нещо друго — <Link to="/contact">пишете ни</Link>.
      </p>
    </>
  )
}

export function AboutEn() {
  return (
    <>
      <p>
        Чети по реда ("read in order") answers the question every large fantasy world starts with: which book do I read first? Each world
        has paths, sequences of books with a beginning and an end, and beside each book it says why it stands exactly there.
      </p>
      <p>The first world is Terry Pratchett's Discworld. The site is built to hold others.</p>
      <h2>How it is made</h2>
      <p>
        The synopses and notes are written by hand, for this site. The Bulgarian titles and the names in the text have been checked against
        the printed Bulgarian editions.
      </p>
      <p>It is a personal project: free, with no advertising, and not affiliated with the authors, their estates or the publishers.</p>
      <p>
        More on what the project is and how it works: <a href="https://about.chetiporeda.com/en">about.chetiporeda.com</a>.
      </p>
      <p>
        A mistake in an order, a world to add, or anything else: <Link to="/contact">write to us</Link>.
      </p>
    </>
  )
}
